"use client";
import { useEffect } from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/app/components/shadcn/alert-dialog";
import useDialog from "@/app/lib/features/dialog/dialog.hook";
import dialogRegistery from "@/app/constants/dialogRegistery";
import { cn } from "@/app/utils/cn";

const Dialog = () => {
  const { dialogs, destroyDialog, getCallbacks } = useDialog();

  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === "Escape" && dialogs.length > 0) {
        const currentDialog = dialogs[dialogs.length - 1];
        destroyDialog(currentDialog.dialogId);
      }
    };

    if (dialogs.length > 0) {
      document.addEventListener("keydown", handleEscape);
    }

    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, [dialogs, destroyDialog]);

  if (dialogs.length === 0) return null;

  return (
    <>
      {dialogs.map((dialog, index) => {
        const dialogConfig = dialogRegistery.find((d) => d.name === dialog.name);
        if (!dialogConfig) {
          return null;
        }

        const callbacks = getCallbacks(dialog.dialogId);

        const handleConfirm = async () => {
          if (callbacks?.onConfirm) {
            await callbacks.onConfirm();
          }
          destroyDialog(dialog.dialogId);
        };

        const handleCancel = () => {
          if (callbacks?.onCancel) {
            callbacks.onCancel();
          }
          destroyDialog(dialog.dialogId);
        };

        return (
          <AlertDialog key={index} open={true} onOpenChange={handleCancel}>
            <AlertDialogContent className="z-9999">
              <AlertDialogHeader>
                <AlertDialogTitle>{dialogConfig.title}</AlertDialogTitle>
                {dialogConfig.description && (
                  <AlertDialogDescription>
                    {dialogConfig.description}
                  </AlertDialogDescription>
                )}
              </AlertDialogHeader>
              <AlertDialogFooter>
                <AlertDialogCancel onClick={handleCancel}>
                  {dialogConfig.cancelText || "İptal"}
                </AlertDialogCancel>
                <AlertDialogAction
                  onClick={handleConfirm}
                  className={cn(
                    dialogConfig.variant === "destructive" &&
                      "bg-destructive text-destructive-foreground text-white hover:bg-destructive/90"
                  )}
                >
                  {dialogConfig.confirmText || "Onayla"}
                </AlertDialogAction>
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialog>
        );
      })}
    </>
  );
};

export default Dialog;
